import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "dropdown", "drawer", "overlay"]

  connect() {
    this.mediaQuery = window.matchMedia("(min-width: 1024px)")
    this.handleBreakpoint = this.handleBreakpoint.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener("change", this.handleBreakpoint)
    } else {
      this.mediaQuery.addListener(this.handleBreakpoint)
    }

    document.addEventListener("keydown", this.handleKeydown)
    this.closeAll()
  }

  disconnect() {
    if (this.mediaQuery?.removeEventListener) {
      this.mediaQuery.removeEventListener("change", this.handleBreakpoint)
    } else if (this.mediaQuery?.removeListener) {
      this.mediaQuery.removeListener(this.handleBreakpoint)
    }

    document.removeEventListener("keydown", this.handleKeydown)
  }

  toggle(event) {
    event?.preventDefault()

    if (this.isDesktop) {
      this.toggleDropdown()
    } else {
      this.toggleDrawer()
    }
  }

  close(event) {
    event?.preventDefault()
    this.closeAll()
  }

  toggleDropdown() {
    if (!this.hasDropdownTarget) return

    if (this.dropdownOpen) {
      this.closeDropdown()
    } else {
      this.openDropdown()
    }
  }

  toggleDrawer() {
    if (!this.hasDrawerTarget) return

    if (this.drawerOpen) {
      this.closeDrawer()
    } else {
      this.openDrawer()
    }
  }

  openDropdown() {
    if (!this.hasDropdownTarget) return

    this.closeDrawer()
    this.dropdownTarget.classList.remove("hidden")
    this.dropdownTarget.setAttribute("aria-hidden", "false")
    this.toggleTarget?.setAttribute("aria-expanded", "true")
  }

  closeDropdown() {
    if (!this.hasDropdownTarget) return

    this.dropdownTarget.classList.add("hidden")
    this.dropdownTarget.setAttribute("aria-hidden", "true")
    this.toggleTarget?.setAttribute("aria-expanded", "false")
  }

  openDrawer() {
    if (!this.hasDrawerTarget) return

    this.closeDropdown()
    this.drawerTarget.classList.remove("hidden")
    this.drawerTarget.setAttribute("aria-hidden", "false")

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
      this.overlayTarget.setAttribute("aria-hidden", "false")
    }

    this.toggleTarget?.setAttribute("aria-expanded", "true")
  }

  closeDrawer() {
    if (!this.hasDrawerTarget) return

    this.drawerTarget.classList.add("hidden")
    this.drawerTarget.setAttribute("aria-hidden", "true")

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
      this.overlayTarget.setAttribute("aria-hidden", "true")
    }

    this.toggleTarget?.setAttribute("aria-expanded", "false")
  }

  closeAll() {
    this.closeDropdown()
    this.closeDrawer()
  }

  handleBreakpoint() {
    this.closeAll()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeAll()
    }
  }

  get isDesktop() {
    return this.mediaQuery?.matches || false
  }

  get dropdownOpen() {
    return this.hasDropdownTarget && !this.dropdownTarget.classList.contains("hidden")
  }

  get drawerOpen() {
    return this.hasDrawerTarget && !this.drawerTarget.classList.contains("hidden")
  }
}
